import React, { useCallback, useState } from 'react';
import Tooltip from '../Tooltip/Tooltip';
import { usePriceTerms } from '../TileKit/hooks';
import { classnames as cx } from '../../utilities';
import './MonthlyPayment.scss';
import FinanceButton from './FinanceButton';

type OwnProps = {
  hasValidTerms: boolean;
  openSoftPullModal: () => void;
  trackMonthlyPaymentClicked: () => void;
  trackMonthlyPaymentCTAClicked: () => void;
};

export default function MonthlyPayment({
  hasValidTerms,
  openSoftPullModal,
  trackMonthlyPaymentClicked,
  trackMonthlyPaymentCTAClicked
}: OwnProps): JSX.Element | null {
  const [showTooltip, setShowTooltip] = useState(false);
  const { monthlyPayment = 0, apr = 0, term, hasTerms } = usePriceTerms();

  const handleCtaClick = useCallback(() => {
    openSoftPullModal();
    trackMonthlyPaymentCTAClicked();
  }, []);

  const handleTooltipClick = useCallback(
    (ev: MouseEvent) => {
      ev.stopPropagation();

      setShowTooltip(v => {
        if (!v) trackMonthlyPaymentClicked();

        return !v;
      });
    },
    [handleCtaClick]
  );

  const hasValidMonthlyPayment = monthlyPayment > 0;

  return hasTerms ? (
    <div
      className={cx('monthly-payment', {
        empty: !hasValidMonthlyPayment
      })}
      data-qa="monthly-payment"
    >
      <div className="est-label">{!hasValidTerms && 'Est.'}</div>
      <Tooltip
        className={cx('terms-tooltip')}
        component={
          <>
            <div className="tooltip-title">
              Monthly Payment of ${monthlyPayment}
            </div>
            <p className="tooltip-text">
              Monthly payment based on a {term} month loan at{' '}
              {(apr * 100).toFixed(2)}% APR.
            </p>
            <FinanceButton
              hasValidTerms={hasValidTerms}
              handleClick={handleCtaClick}
            />
          </>
        }
        onClick={handleTooltipClick}
        open={showTooltip}
        qaName="monthly-payment"
        right
      >
        ${monthlyPayment}/mo
      </Tooltip>
    </div>
  ) : null;
}
